const ARROW_PATHS: Record<string, { stroke: string; d: [string, string] }> = {
  "↑": { stroke: "#22c55e", d: ["M12 19V5", "m5 12 7-7 7 7"] },
  "↗": { stroke: "#22c55e", d: ["M7 17 17 7", "M7 7h10v10"] },
  "↓": { stroke: "#ef4444", d: ["M12 5v14", "m19 12-7 7-7-7"] },
  "↘": { stroke: "#ef4444", d: ["M7 7 17 17", "M17 7v10H7"] },
  "→": { stroke: "#a1a1aa", d: ["M5 12h14", "m12 5 7 7-7 7"] },
};

/** 추세 화살표(↑↗↓↘→) SVG 아이콘. 매칭 안 되는 문자는 null */
export function ArrowIcon({ char, size = 13 }: { char: string; size?: number }) {
  const a = ARROW_PATHS[char];
  if (!a) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={a.stroke}
    >
      <path d={a.d[0]} />
      <path d={a.d[1]} />
    </svg>
  );
}

/** 텍스트 내 화살표 문자(↑↗↓↘→)를 SVG 아이콘으로 치환해 렌더 */
export function TrendText({ text, size = 13 }: { text: string; size?: number }) {
  const parts = text.split(/([←-⇿⬀-⯿])/g);
  return (
    <>
      {parts.map((part, i) =>
        ARROW_PATHS[part] ? (
          <span key={i} className="inline-flex items-center align-middle mx-px">
            <ArrowIcon char={part} size={size} />
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
}
